export default function UserInformationTab({ profileInfo }) {
  const unixToPersianDate = (unix) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(unix) * 1000).toLocaleDateString("fa-IR", options);
    date.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
    return date;
  };
  // gender
  // province

  return (
    <div class="tab-pane fade show active" id="user-information" role="tabpanel" aria-labelledby="home-tab">
      <div className="user-management-container user-report-information-tab text-center ">
        <div className="user-information-container mx-auto d-flex my-3   flex-row  flex-wrap w-100">
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">نام </div>
            <div className="description mt-2">{profileInfo.fname}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">نام خانوادگی </div>
            <div className="description mt-2">{profileInfo.lname}</div>
          </div>

          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">نام کاربری </div>
            <div className="description mt-2">{profileInfo.username}</div>
          </div>

          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">نام پدر </div>
            <div className="description mt-2">{profileInfo.fathername}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">کد ملی</div>
            <div className="description mt-2">{profileInfo.codemelli}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">وضعیت</div>
            <div className="description mt-2">{parseInt(profileInfo.mainstatus) ? "فعال" : "غیرفعال"} </div>
          </div>

          {/* <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">پسوورد </div>
            <div className="description mt-2">{profileInfo.password}</div>
          </div> */}
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">آدرس </div>
            <div className="description mt-2">{profileInfo.address}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">تلفن </div>
            <div className="description mt-2">{profileInfo.tell}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">موبایل</div>
            <div className="description mt-2">{profileInfo.mobile}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">ایمیل</div>
            <div className="description mt-2">{profileInfo.email}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">شهر </div>
            <div className="description mt-2">{profileInfo.city.title}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">استان </div>
            <div className="description mt-2">{profileInfo.province.title}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">تاریخ تولد </div>
            <div className="description mt-2">{profileInfo.bdyear + "/" + profileInfo.bdmonth + "/" + profileInfo.bdday}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">جنسیت </div>
            <div className="description mt-2">{+profileInfo.jender ? "مونث" : "مذکر"}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">تاریخ عضویت </div>
            <div className="description mt-2">{unixToPersianDate(profileInfo.mtm)}</div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">عکس پروفایل </div>
            <div className="description mt-2 profile-pic-container text-center mx-auto" style={{ width: "40px", height: "40px" }}>
              <img src={"http://mvc.dade24.ir/" + profileInfo.profilepic} style={{ width: "100%", height: "100%", borderRadius: "50%" }} alt=""></img>
            </div>
          </div>
          <div className="user-information-item d-flex flex-column  p-2 px-3">
            <div className="title">نوع اکانت </div>
            <div className="description mt-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
